import React from 'react';
import PropTypes from 'prop-types';

import { leadTimeTitle } from '../messages/pdpBlurbMessages';

import styles from './PdpSharedLeadTime.scss';

import classnames from 'classnames';

export function PdpSharedLeadTime({ leadTime, isFreeShippingTestVariant }) {
    return (
        <React.Fragment>
            <span data-tn="swatch-lead-time">
                <span className={styles.label}>{leadTimeTitle}</span>
                <span
                    className={classnames(styles.value, {
                        [styles.valueColorFreeShippingTest]: isFreeShippingTestVariant,
                    })}
                >
                    {leadTime}
                </span>
            </span>
        </React.Fragment>
    );
}

PdpSharedLeadTime.propTypes = {
    leadTime: PropTypes.string,
    isFreeShippingTestVariant: PropTypes.bool,
};
